import BaseApiClient from '../BaseApiClient';
import { ListDataParams, ListDataResponse } from '../types';
import { JobTitleInterface } from '../../interfaces/JobTitle.interface';

export class ApiConfig extends BaseApiClient {
  /**
   * Gets list of job titles
   */
  async listJobTitles(
    listData: ListDataParams,
    searchTerm?: string
  ): Promise<ListDataResponse<JobTitleInterface>> {
    return new Promise((resolve, reject) => {
      if (searchTerm) {
        if (!listData.filters) listData.filters = {};
        listData.filters.uuid = searchTerm;
      }
      this.client
        .getList('/job-title', listData)
        .then((res) => {
          if (res.data) {
            resolve({
              items: res.data.data,
              pagination: {
                page: res.data.meta?.page,
                perPage: res.data.meta?.per_page,
                total: res.data.meta?.total
              }
            });
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }
}

export { configQueryKeys } from './query-keys';
export type { ConfigJobTitlesListParams } from './query-keys';
export { useConfigJobTitlesQuery } from './use-config-queries';

